<template>
  <div id="app" v-title data-title="全网爆率最高实物盲盒，现货包邮，即开即取，100%正品，iphone、AJ、yeezy、各类手办等你来拿">
    <router-view v-if="isRouterAlive" />
  </div>
</template>

<script>
import store from '@/store'
export default {

  name: "App",
  provide() {
    return {
      reload: this.reload,
      userInfo: {}
    };
  },
  data() {
    return {
      isRouterAlive: true,
    };
  },
  created() {
    this.getData()
  },
  mounted() { },
  methods: {
    getData() {
      this.$doGet("/api/setting.Setting/setting").then((res) => {
        store.state.setting = res.data
      }).catch(() => { })
    },
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true;
      });
    }
  },
  components: {},
};
</script>

<style lang="less">
@import '~@/assets/css/media.less';
@import '~@/assets/css/index.less';
@import '~@/assets/css/open-animation.less';
@import '~@/assets/css/open-box.less';
</style>
